export default "__VITE_ASSET__CDzEwF8A__"